<template>
  <!-- 城市额度管理 -->
  <div>
    <app-page>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <div class="fan-search-col fan-search-right" v-if="$has('BBZQGL-CSEDGL-XZ')">
            <el-button type="primary" :size="formSize" @click="handleModify(false)" v-track trackCode='baibuBillQuotaList-1'>新增</el-button>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        />
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 启用禁用弹窗 -->
    <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="subAccountObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="setDivideApproval"
    />
    <!-- 新增/编辑 -->
    <modify-dialog
      :visible.sync="isModifyShow"
      :is-modify="isModify"
      :cityId="currentRow.cityId"
      @success="getList"
    />
  </div>
</template>

<script>
import { getCityBopList, setCitySwitch } from '@/api/baibu-bill';
import { setStatusColor } from '@/filters/index';
import modifyDialog from './components/modify-dialog';

const queryFormDefault = {
  creditStatus: '', // 授信状态 ON=正常;OFF=已停用
  page: 1,
  limit: 20,
};

export default {
  name: 'BaibuBillQuotaList',
  components: { modifyDialog },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      selectList: [
        {
          title: '授信状态',
          prop: 'creditStatus',
          dictionaryPath: '/finance/finance-receipt/CreditStatus',
        },
      ],
      tableColumn: [
        { prop: 'cityNo', label: '城市编号', minWidth: '1' },
        { prop: 'cityName', label: '城市名称', minWidth: '1' },
        { prop: 'deposit', label: '保证金(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'depositRate', label: '保证金占比' },
        { prop: 'creditQuota', label: '总授信额度(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'usableQuota', label: '剩余可用额度(元)', filterName: 'toFenThousandsAndFloat' },
        // ON=正常;OFF=已停用
        { label: '授信状态', status: 'creditStatus', statusDesc: 'creditStatusDesc', statusColor: (val) => setStatusColor(val, 'creditStatus') },
        {
          label: '操作',
          prop: 'operate',
          width: '145px',
          disabled: true,
          btnGroups: [
            {
              name: '启用',
              plain: true,
              className: ['table-button', 'table-button-success'],
              icon: 'el-icon-success',
              trackCode: 'baibuBillQuotaList-3',
              showBtn: (row) => this.$has('BBZQGL-CSEDGL-QY') && row.creditStatus === 'OFF',
              click: (row) => this.handleOperateState('ON', row),
            },
            {
              name: '禁用',
              plain: true,
              className: ['table-button', 'table-button-danger'],
              icon: 'el-icon-error',
              trackCode: 'baibuBillQuotaList-4',
              showBtn: (row) => this.$has('BBZQGL-CSEDGL-JY') && row.creditStatus === 'ON',
              click: (row) => this.handleOperateState('OFF', row),
            },
            {
              name: '编辑',
              plain: true,
              className: ['table-button', 'table-button-primary'],
              trackCode: 'baibuBillQuotaList-2',
              showBtn: () => this.$has('BBZQGL-CSEDGL-BJ'),
              click: (row) => this.handleModify(true, row),
            },
          ],
        },
      ],

      /** ------操作-------- */
      isOperateStateShow: false, // 启用禁用弹窗
      submitLoading: false,
      textConfig: {}, // 弹窗页面提示文案
      subAccountObj: {}, // 启用禁用对象

      /** ------新增/编辑-------- */
      isModifyShow: false,
      isModify: false,
      currentRow: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 新增/编辑
    handleModify(flag, row = {}) {
      this.isModify = flag;
      this.isModifyShow = true;
      this.currentRow = { ...row };
    },
    // 启用禁用操作请求接口
    async setDivideApproval(params) {
      try {
        this.submitLoading = true;
        console.log(params);
        await setCitySwitch(params);
        this.$message({ message: '操作成功！', type: 'success' });
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.handleSearch();
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
    /**
     * 打开启用禁用弹窗
     * cityNo     城市编号
     * operate  操作（ON-启用，OFF-停用）
    */
    handleOperateState(operate, row) {
      this.subAccountObj = {
        cityNo: row.cityNo,
        operate,
      };
      const list = {
        ON: {
          title: '人工确认',
          messageTip: '是否【启用】该城市授信额度？',
          isPass: true,
        },
        OFF: {
          title: '人工确认',
          messageTip: '是否【禁用】该城市授信额度？',
          isPass: true,
        },
      };
      this.textConfig = list[operate] || '-';
      this.isOperateStateShow = true;
    },

    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 处理提交接口的参数（列表/导出）
    newAPiParam() {
      const params = JSON.parse(JSON.stringify(this.queryForm));
      delete params.timeType;
      return params;
    },
    // 列表接口请求
    async getList() {
      try {
        const params = this.newAPiParam();
        this.loading = true;
        this.list = [];
        const res = await getCityBopList(params);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
